export default __webpack_public_path__ + "static/media/Akhlak Hossain Jim 480.5431faf5.webp";